
      import Info from './info.vue'
      import type { App, Plugin } from 'vue'

      export const InfoPlugin: Plugin = {
        install(app: App) {
          app.component('Info', Info)
        },
      }
      export { Info }
      